import { __assign as r } from "./_virtual/_tslib.js";
import o from "./loadPlugins.js";
import t, { useImperativeHandle as i } from "react";
import { useBindProp as s } from "./hooks/props.js";
import { getInitialOptionsFromProps as n } from "./utils/options.js";
import e from "./hooks/component.js";
import m from "./hooks/common/district-layer.js";
var p = t.forwardRef(function (t, p) {
  var c = e({
    prepare: function prepare() {
      return o("AMap.DistrictLayer");
    },
    init: function init(o) {
      var i = r({}, n(t));
      return "soc" in i && (i.SOC = i.soc, delete i.soc), new o.DistrictLayer.Country(i);
    }
  }, t);
  return i(p, function () {
    return c;
  }, [c]), m(c, t), s(c, {
    setter: "setSOC"
  }, t.soc), null;
});
export default p;